export const environment = {
  production: true,
  serviceWorker: true,
  apiLocations: {
    cookieDomain: '.dermalogic.health',
    cookieName: 'AmatisTeleHealth-prod',
    identity: '/identity/api/v1',
    patient: '/patient/api/v1',
    patientHub: '/patient-hub',
    customer: '/customer/api/v1',
    chat: '/chat/api/v1',
    notification: '/notification/api/v1',
    backOffice: 'https://backoffice.dermalogic.health',
    invoice: '/invoice/api/v1',
  },
};
